<template>
  <div>
    <h2 class="text-center">let's start {{questions[index].category}} Quizz</h2>
    <questionsnav
     :numTotal="numTotal"
     :numCorrect="numCorrect"
    />
    <b-container class="bv-example-row">
    <b-row>
     <b-col sm="6" offset="3">
    <questions
     v-if="questions.length"
     :questions="questions"
     :index="index"
     :increase="increase"
     :next="next"
     :currentquestions="questions[index]"
    />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import questions from '@/components/questions/questions.vue'
import questionsnav from '@/components/questions/questionsnav.vue'
export default {
  name: 'animals',
  components: {
    questions,
    questionsnav
  },
  data () {
    return {
      questions: [],
      index: 0,
      numTotal: 0,
      numCorrect: 0
    }
  },
  methods: {
    next () {
      this.index++
    },
    increase (isCorrect) {
      if (isCorrect) {
        this.numCorrect++
      }
      this.numTotal++
    }

  },
  mounted () {
    fetch('https://opentdb.com/api.php?amount=40&category=28&type=multiple', {
      method: 'get'
    })
      .then(response => {
        return response.json()
      })
      .then(jsonData => {
        this.questions = jsonData.results
      })
  }
}
</script>
